package com.rainbowclubs.rainbow.presentation.select_club

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.rainbowclubs.rainbow.data.models.Club
import com.rainbowclubs.rainbow.data.responses.SelectClubResponse
import com.rainbowclubs.rainbow.domain.use_cases.club.CacheSelectedClubUseCase
import com.rainbowclubs.rainbow.domain.use_cases.login.SelectClubUseCase
import com.rainbowclubs.rainbow.presentation.ScreenState
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.receiveAsFlow
import kotlinx.coroutines.launch

class SelectClubViewModel(
    private val selectClubUseCase: SelectClubUseCase,
    private val cacheSelectedClubUseCase: CacheSelectedClubUseCase,
) : ViewModel() {
    sealed class NavigationEvent {
        object Back : NavigationEvent()
        data class Home(val clubId: String) : NavigationEvent()
        data class MembershipData(val clubId: String) : NavigationEvent()
    }

    val screenState: StateFlow<ScreenState<SelectClubResponse>>
        field: MutableStateFlow<ScreenState<SelectClubResponse>> = MutableStateFlow(ScreenState.Loading)

    private val navigationIntentChannel = Channel<NavigationEvent>(Channel.BUFFERED)
    val navigationIntent: Flow<NavigationEvent> = navigationIntentChannel.receiveAsFlow()

    fun fetchData() {
        viewModelScope.launch {
            selectClubUseCase.invoke().onSuccess {
                screenState.value = ScreenState.Content(it)
            }.onFailure {
                screenState.value = ScreenState.Error(it)
            }
        }
    }

    fun onButtonClicked(club: Club, isRequest: Boolean) {
        if (isRequest) {
            viewModelScope.launch {
                navigationIntentChannel.send(NavigationEvent.MembershipData(clubId = club.id))
            }
        } else {
            viewModelScope.launch {
                cacheSelectedClubUseCase(club.id)
                navigationIntentChannel.send(NavigationEvent.Home(clubId = club.id))
            }
        }
    }
}
